'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var breakpoints = ['768px', '992px', '1200px'];

exports.default = breakpoints;
